"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = replaceBucketKeysWithUrlsInArray;

var _replaceBucketKeysWithUrls = _interopRequireDefault(require("./replaceBucketKeysWithUrls"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Takes an array of data objects and swaps out any defined key/bucketKey values with pre-signed urls
 * in each item. Supports nested keys/subkeys.
 *
 * eg.
 *
 * [
 *  { foo: '/foo/foobar.jpg' },
 *  { foo: '/bar/barfoo.jpg' }
 * ], ['foo']
 *
 *    =>
 *
 * [
 *  { foo: 'aws.com/.../foo/foobar.jpg' },
 *  { foo: 'aws.com/.../bar/barfoo.jpg' }
 * ]
 *
 * @param {*} apiClient
 * @param {Array<Object>} dataArray
 * @param {Array<SubstitutedKey>} substitutedKeys
 * @param {string} organisationId
 *
 * @return {Promise<*>}
 */


function replaceBucketKeysWithUrlsInArray(_x) {
  return _replaceBucketKeysWithUrlsInArray.apply(this, arguments);
}

function _replaceBucketKeysWithUrlsInArray() {
  _replaceBucketKeysWithUrlsInArray = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var apiClient, dataArray, substitutedKeys, organisationId, ignorePattern;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            apiClient = _ref.apiClient, dataArray = _ref.dataArray, substitutedKeys = _ref.substitutedKeys, organisationId = _ref.organisationId, ignorePattern = _ref.ignorePattern;
            return _context.abrupt("return", Promise.all(dataArray.map(function (dataItem) {
              return (0, _replaceBucketKeysWithUrls.default)({
                apiClient: apiClient,
                data: dataItem,
                substitutedKeys: substitutedKeys,
                organisationId: organisationId,
                ignorePattern: ignorePattern
              });
            })));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _replaceBucketKeysWithUrlsInArray.apply(this, arguments);
}